'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { cn } from '@core/utils';
interface DonationBenefitTexts {
  donationAmountText: string;
  benefitsText: string;
  totalBenefitText: string;
}
interface DonationBenefit {
  label: string;
  isHighlighted?: boolean;
  texts: DonationBenefitTexts;
}
export interface DonationComparisonCardProps {
  minBenefit: DonationBenefit;
  maxBenefit: DonationBenefit;
  className?: string;
}
export const DonationComparisonCard = t0 => {
  const $ = _c(10);
  const {
    minBenefit,
    maxBenefit,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full items-center", "mobile-tablet:rounded-none mobile-tablet:bg-transparent mobile-tablet:p-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== minBenefit) {
    t2 = <BenefitColumn benefit={minBenefit} position="left" />;
    $[2] = minBenefit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== maxBenefit) {
    t3 = <BenefitColumn benefit={maxBenefit} position="right" />;
    $[4] = maxBenefit;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
interface BenefitColumnProps {
  benefit: DonationBenefit;
  position: 'left' | 'right';
}
const BenefitColumn = t0 => {
  const $ = _c(21);
  const {
    benefit,
    position
  } = t0;
  const isLeft = position === "left";
  const t1 = isLeft ? "rounded-l-large bg-Gray-white mobile-tablet:bg-Gray-25" : "rounded-r-large bg-O-25 mobile-tablet:bg-O-25";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex flex-1 items-center p-24 mobile-tablet:px-12 mobile-tablet:py-20", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = benefit.isHighlighted ? "bg-O-400 text-Gray-white" : "bg-Gray-200 text-Gray-black";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("font-600 typo-caption2", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== benefit.label || $[5] !== t4) {
    t5 = <Badge className={t4}>{benefit.label}</Badge>;
    $[4] = benefit.label;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== benefit.texts.donationAmountText) {
    t6 = <p className="font-700 text-Gray-black typo-body4">{benefit.texts.donationAmountText}</p>;
    $[7] = benefit.texts.donationAmountText;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== benefit.texts.benefitsText) {
    t7 = <p className="whitespace-pre-line text-center font-500 text-Gray-800 typo-body4">{benefit.texts.benefitsText}</p>;
    $[9] = benefit.texts.benefitsText;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== benefit.texts.totalBenefitText) {
    t8 = <p className="whitespace-nowrap font-700 text-O-400 typo-body4">{benefit.texts.totalBenefitText}</p>;
    $[11] = benefit.texts.totalBenefitText;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className="flex flex-1 flex-col items-center gap-8">{t5}{t6}{t7}{t8}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t9) {
    t10 = <div className={t2}>{t9}</div>;
    $[18] = t2;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};